// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c9b0ba74","455":"90346789","977":"a1c70cac"}[chunkId] + ".chunk.js";
};